<div class="card">
  <div class="tab-wrapper">
      <div class="tab-rightmenu-wrapper">
          <label (click)="applyAutoMapping()" class="p-text-right pointer p-mr-2" style="color: var(--primary-color);">
              <span class="pi pi-refresh"></span>
              Auto Mapping
          </label>
          <ng-container>
              <span>|</span>
              <label (click)="unmapAllFields()" class="p-text-right pointer p-mr-2 p-ml-2" style="color: var(--primary-color);">
                  <span class="pi pi-refresh"></span>
                   Unmap
              </label>
          </ng-container>
          <span>|</span>
          <label (click)="loadTemplateFields()" class="p-text-right pointer p-ml-2" style="color: var(--primary-color);">
              <span class="pi pi-cog"></span>
              Template Fields
          </label>
      </div>
      <p-tabView [(activeIndex)]="selectedTabIndex" class="custom-tablist custom-tablist-button tab-rightmenu" [scrollable]="true">
          <p-tabPanel header="All">
              <ng-container *ngTemplateOutlet="importMapTemplate"></ng-container>
          </p-tabPanel>
          <p-tabPanel header="Mapped Columns({{mappedFieldsCount}})">
              <ng-container *ngTemplateOutlet="importMapTemplate"></ng-container>
          </p-tabPanel>
          <p-tabPanel header="Unmapped Columns({{unMappedFieldsCount}})">
              <ng-container *ngTemplateOutlet="importMapTemplate"></ng-container>
          </p-tabPanel>
      </p-tabView>

      <ng-template #importMapTemplate>
          <div class="p-grid">
              <div class="p-col-12">
                  <p-table [value]="selectedFileHeaders |  importMapFilter: selectedTabIndex:true">
                      <ng-template pTemplate="header" let-columns>
                          <tr>
                              <th class="p-col-3"> <span *ngIf="isCopyMoveWBRows">Source </span>Workbook Fields</th>
                              <th class="p-col-3"><span *ngIf="isCopyMoveWBRows">Target </span>{{ selectedModule?.name }} Fields</th>
                              <th class="p-col-6"></th>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-field let-rowIndex="rowIndex">
                          <tr>
                            <td class="p-col-3">
                              <strong>{{field.excelHeader}}</strong>
                              <span class="pi pi-info-circle" 
                                  pTooltip="Datatype: {{field?.dataType | titlecase}}" 
                                  tooltipPosition="top" 
                                  style="margin-left: 5px; cursor: pointer;">
                              </span>
                            </td>
                            <td class="p-col-3">
                                  <button pButton type="button" icon="pi pi-plus" label="Select Fields" class="p-button-text"
                                  (click)="toggleTreeTable(rowIndex, field)">
                                  </button>
                              </td>
                              <td class="p-col-6">
                                  <ng-container *ngIf="field.moduleFields?.length">
                                      <div class="p-d-flex p-flex-wrap">
                                          <p-chip 
                                            *ngFor="let item of field.moduleFields" 
                                            styleClass="p-mr-2 custom-chip" 
                                            label="{{ item?.labelName }}" 
                                            [removable]="true" 
                                            (onRemove)="removeNode(field, item)">
                                          </p-chip>
                                      </div>
                                  </ng-container>
                              </td>  
                      <p-dialog
                      *ngIf="treeTableVisibleIndex[rowIndex]"
                      [(visible)]="treeTableVisibleIndex[rowIndex]"
                      [modal]="true"
                      [closable]="true"
                      [header]="'Select Mapping For ' + field.excelHeader"
                      [style]="{ width: '50vw'}"
                      
                    >
                    <div class="p-mt-3 p-mb-3 p-mr-3 p-d-flex p-jc-end p-w-200">
                      <span class="p-input-icon-right">
                        <i class="pi pi-times filter-icon" (click)="applyTreetableFilter(treeTable, '')"></i>
                        <input
                          pInputText
                          type="text"
                          [(ngModel)]="globalFilterValue"
                          (input)="applyTreetableFilter(treeTable, globalFilterValue)"
                          placeholder="Search Field Name"
                        />
                      </span>
                    </div>

                      <p-treeTable
                      #treeTable
                        [value]="treeData"
                        [scrollable]="true"
                        selectionMode="multiple"
                        [(selection)]="tempSelectedNodes[field.excelHeader]"
                        dataKey="id"
                        [globalFilterFields]="['label']"
                        [filterMode]="'strict'"
                      >
                        <ng-template pTemplate="header">
                          <tr>
                            <th>Field Name</th>
                          </tr>
                        </ng-template>
                    
                      <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                        <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode" (click)="onNodeSelect(rowNode, field.excelHeader)"
                          [ttSelectableRowDisabled]="!rowNode?.node?.selectable">
                          <ng-container *ngIf="!isCopyMoveWBRows || rowData?.fields?.length || (rowData?.field && rowData?.formControl === field?.excelColumn && isCopyMoveWBRows)">
                          <td>
                            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                            {{ rowData?.label }}
                          </td>
                        </ng-container>
                          </tr>
                        </ng-template> 
                      </p-treeTable>
                      <ng-template      
                      pTemplate="footer">
                          <div class="p-d-flex 
                                p-jc-end p-gap-2">
                            <button pButton type="button" label="Cancel" (click)="treeTableVisibleIndex[rowIndex] = false"></button>
                            <button pButton type="button" label="Save" (click)="saveNodeSelection(field); treeTableVisibleIndex[rowIndex] = false"></button>
                          </div>
                        </ng-template>
                    </p-dialog>
                  </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                          <tr>
                              <td colspan="10">
                                  <div *ngIf="selectedTabIndex == 0" class="p-text-center">The file doesn't have any columns.</div>
                                  <div *ngIf="selectedTabIndex == 1" class="p-text-center">No columns have been mapped yet.</div>
                                  <div *ngIf="selectedTabIndex == 2" class="p-text-center">No columns remain to be mapped.</div>
                              </td>
                          </tr>
                      </ng-template>
                  </p-table>
              </div>
          </div>
      </ng-template>
  </div>
</div>
<app-shared-import-sample-modal *ngIf="displayTemplateFields"
[displayImportSample]="displayTemplateFields"
[selectedModule]="selectedModule"
[sectionColumns]="templateSectionColumns"
[loadFields]="true"
(fieldsUpdated)="templateFieldsRefresh($event)"
(dialogClosed)="closeTemplateFields()">
</app-shared-import-sample-modal>